<template>
    <div class="tabHome">
       <ul>
           <li v-for="(item,index) in tabHome" :key="index">
               <a v-if="item.ShowType == 2" :href="'http://lishui.yeshiweb.com:8081/web//Detail/VideoDetail?col_id='+item.ColId+'&art_id='+item.Id">
                    <p><span>{{date[index]}}</span><i>{{month[index]}}</i></p>
                    <h3>{{item.ArtTitle}}</h3>
                    <h4 v-html="item.BodyInfo"></h4>
               </a>
               <a v-if="item.ShowType == 5" :href="item.OutLink">
                    <p><span>{{date[index]}}</span><i>{{month[index]}}</i></p>
                    <h3>{{item.ArtTitle}}</h3>
                    <h4 v-html="item.BodyInfo"></h4>
               </a>
                <router-link v-if="item.ShowType == 1" :to="{ path: '/artical',query:{colid:item.Id}}">
                    <p><span>{{date[index]}}</span><i>{{month[index]}}</i></p>
                    <h3>{{item.ArtTitle}}</h3>
                    <h4 v-html="item.BodyInfo"></h4>
               </router-link>
           </li>
       </ul>
    </div>
</template>

<script>
import api from '../assets/config/api'
import axios from 'axios'
export default {
data() {
    return {
        tabHome:[],
        month:[],
        date:[]
    };
},
props:['col_ids'],
computed: {

},
async mounted() {
    var colids = this.col_ids
    await axios.post(api.atrDetail, {
        col_ids:colids,page_index:1,page_size:4
    })
    .then(response => {
        //console.log(response.data.Items);
        this.tabHome = response.data.Items
        for(let i =0;i<4;i++){
            this.month[i] = this.tabHome[i].PublishDate.substr(0, 4)+'.'+this.tabHome[i].PublishDate.substr(5, 2)
            this.date[i] = this.tabHome[i].PublishDate.substr(8, 2)
        }
        //console.log(this.month)
    })
    .catch(function (error) {
        console.log(error);
    });
},

}
</script>
<style lang="less" scoped>
.tabHome{
    ul{
        li{
            height: 95px;
            overflow: hidden;
            padding-bottom: 8px;
            position: relative;
            p{
                width: 95px;
                height: 95px;
                background: url(../assets/images/hometab.png) no-repeat 0 0;
                float: left;
                position: relative;
                span{
                    font-size: 46px;
                    color: #f54c00;
                    display: block;
                    position: absolute;
                    top: 5px;
                    left: 6px;
                    width: 78px;
                    text-align: center;
                }
                i{
                    font-style: normal;
                    color: #494c5a;
                    font-size: 12px;
                    position: absolute;
                    bottom: 20px;
                    left: 6px;
                    display: block;
                    width: 78px;
                    text-align: center;
                }
            }
            h3{
                font-weight: normal;
                line-height: 30px;
                height: 30px;
                overflow: hidden;
                font-size: 22px;
                color: #4a4c60;
                padding-top: 5px;
                &:hover{
                    color: #faa27a;
                }
            }
            h4{
                font-weight: normal;
                line-height: 18px;
                max-height: 36px;
                overflow: hidden;
                font-size: 14px;
                color: #666;
                padding-top: 10px;
            }
        }
    }
}
</style>